import queryString from 'query-string';
import { isEmpty } from 'lodash';
import {
  PRODUCT_ID_DHCI,
  PRODUCT_ID_PRIMERA,
  PRODUCT_ID_LIST,
  DHCI_OPT_OPTIONS,
  PRIMERA_OPT_OPTIONS,
  PRODUCT_ID_OAAS,
  PRODUCT_ID_ALLETRAB10K,
  PRODUCT_ID_FILE,
  PRODUCT_ID_PCBE,
  HPE_GREENLAKE_CLOUD_PLATFORM,
  HPE_GREENLAKE_DEDICATED_PLATFORM,
  PRIMERA_OPT_FACTORY,
  MODEL_ALLETRAMP,
} from '../constants';

export const historyPush = (url, location, history) => {
  const urlSearchString = location ? location.search : '';
  history.push({
    pathname: url,
    search: urlSearchString,
  });
};

export const getQueryStringValues = (location) => {
  const urlSearchString = location ? location.search : '';
  return queryString.parse(urlSearchString);
};

export const ChangeQueryString = (newValue, location, history) => {
  const urlSearchString = location ? location.search : '';
  let values = queryString.parse(urlSearchString);
  values = isEmpty(newValue) ? {} : { ...values, ...newValue };
  const searchString = queryString.stringify(values);
  history.replace({
    pathname: location.path,
    search: searchString,
  });
};

export const capitalizeFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getQueryString = (location) => {
  return location ? location.search : '';
};

export const getPageName = (location) => {
  if (!location) {
    return '';
  }
  const pathNames = location.pathname.split('/');
  let pageName = pathNames[pathNames.length - 1];
  if (pageName.match(/\D/) === null) {
    // if pageName contains only digits, it is step number in wizard page
    pageName = `${pathNames[pathNames.length - 2]}-${
      pathNames[pathNames.length - 1]
    }`;
  }

  return pageName;
};

export const validatePageQueryString = (location, history) => {
  const urlSearchString = location ? location.search : '';
  const qsValues = queryString.parse(urlSearchString);
  const {
    product,
    model,
    storagepurchaseopt,
    connectopt,
    opt,
    greenlakeplatform,
    hypervisoropt,
  } = qsValues;

  if (!PRODUCT_ID_LIST.includes(product)) {
    history.replace('/');
    return;
  }

  const pathName = location.pathname;
  if (pathName.indexOf('getting-started/select-model') !== -1) {
    return;
  }

  const selectModePageUrl = '/getting-started/select-model';

  if (!model) {
    history.replace({
      pathname: selectModePageUrl,
      search: queryString.stringify({ ...qsValues, model: '' }),
    });
    return;
  }

  let validationErrors = null;
  switch (product) {
    case PRODUCT_ID_OAAS:
      if (storagepurchaseopt && model && !connectopt) {
        validationErrors = { connectopt: '' };
      }
      break;
    case PRODUCT_ID_ALLETRAB10K: {
      const newValues = {};
      if (model) {
        if (!opt) newValues.opt = '';
        if (!greenlakeplatform) newValues.greenlakeplatform = '';
        if (
          greenlakeplatform === HPE_GREENLAKE_CLOUD_PLATFORM &&
          opt &&
          !connectopt
        ) {
          newValues.connectopt = '';
        }
      }
      if (Object.keys(newValues).length > 0) {
        validationErrors = newValues;
      }
      break;
    }
    case PRODUCT_ID_FILE:
      if (!storagepurchaseopt) {
        validationErrors = { storagepurchaseopt: '' };
      }
      break;
    case PRODUCT_ID_PCBE:
      if (!storagepurchaseopt) {
        validationErrors = { storagepurchaseopt: '' };
      } else if (model === MODEL_ALLETRAMP && !hypervisoropt) {
        validationErrors = { hypervisoropt: '' };
      }
      break;
    case PRODUCT_ID_DHCI: {
      const pageOpt = qsValues['opt'];
      if (!pageOpt || !DHCI_OPT_OPTIONS.includes(pageOpt)) {
        validationErrors = { opt: '' };
      }
      break;
    }
    case PRODUCT_ID_PRIMERA: {
      const pageOpt = qsValues['opt'];
      if (!pageOpt || !PRIMERA_OPT_OPTIONS.includes(pageOpt)) {
        validationErrors = { opt: '' };
      }
      break;
    }
    default:
      break;
  }

  if (validationErrors) {
    history.replace({
      pathname: selectModePageUrl,
      search: queryString.stringify({ ...qsValues, ...validationErrors }),
    });
    return;
  }

  let cleanupRules = null;
  if (product === PRODUCT_ID_ALLETRAB10K) {
    const cleanup = {};
    if (
      greenlakeplatform === HPE_GREENLAKE_DEDICATED_PLATFORM &&
      'connectopt' in qsValues
    ) {
      cleanup.connectopt = undefined;
    }
    if (opt === PRIMERA_OPT_FACTORY && 'cabletray' in qsValues) {
      cleanup.cabletray = undefined;
    }
    if (Object.keys(cleanup).length > 0) {
      cleanupRules = cleanup;
    }
  }

  if (cleanupRules) {
    const finalQs = { ...qsValues };
    for (const key in cleanupRules) {
      if (cleanupRules[key] === undefined) {
        delete finalQs[key];
      }
    }
    history.replace({
      pathname: location.pathname,
      search: queryString.stringify(finalQs),
    });
  }
};

export const validateSelectors = ({ location, history, modelList }) => {
  const urlSearchString = location ? location.search : '';
  const qsValues = queryString.parse(urlSearchString);
  const product = qsValues['product'];
  const model = qsValues['model'];
  const modelDocConfig = modelList[model];
  const selectModePageUrl = '/getting-started/select-model/';
  const storagepurchaseopt = qsValues['storagepurchaseopt'];
  const opt = qsValues['opt'];
  const greenlakeplatform = qsValues['greenlakeplatform'];
  const connectopt = qsValues['connectopt'];
  const hypervisoropt = qsValues['hypervisoropt'];
  if (!modelDocConfig) {
    let newValues = { model: '' };
    if (product === PRODUCT_ID_OAAS && storagepurchaseopt && model) {
      newValues = { connectopt: '' };
    } else if (product === PRODUCT_ID_ALLETRAB10K) {
      if (!model && !opt && !greenlakeplatform) {
        newValues = { model: '', opt: '', greenlakeplatform: '' };
      } else if (model && !opt && !greenlakeplatform) {
        newValues = { opt: '', greenlakeplatform: '' };
      } else if (model && opt && !greenlakeplatform) {
        newValues = { greenlakeplatform: '' };
      }

      if (
        greenlakeplatform === HPE_GREENLAKE_CLOUD_PLATFORM &&
        model &&
        opt &&
        !connectopt
      ) {
        newValues = { connectopt: '' };
      } else if (greenlakeplatform === HPE_GREENLAKE_DEDICATED_PLATFORM) {
        if (connectopt) {
          delete qsValues.connectopt;
        }
      }
    } else if (product === PRODUCT_ID_FILE && !storagepurchaseopt) {
      newValues = { storagepurchaseopt: '', model: '' };
    } else if (product === PRODUCT_ID_PCBE) {
      if (!storagepurchaseopt && !model) {
        newValues = { storagepurchaseopt: '', model: '' };
      } else if (!hypervisoropt && opt && model && storagepurchaseopt) {
        newValues = { hypervisoropt: '' };
      }
    }
    const newQs = { ...qsValues, ...newValues };
    if (JSON.stringify(newQs) !== JSON.stringify(qsValues)) {
      history.replace({
        pathname: selectModePageUrl,
        search: queryString.stringify(newQs),
      });
    }
    return false;
  } else {
    switch (product) {
      case PRODUCT_ID_DHCI:
      case PRODUCT_ID_PRIMERA: {
        const pageOpt = qsValues['opt'];
        const pageOpts =
          product === PRODUCT_ID_DHCI ? DHCI_OPT_OPTIONS : PRIMERA_OPT_OPTIONS;
        if (!pageOpts.includes(pageOpt)) {
          const newValues = { opt: '' };
          const newQs = { ...qsValues, ...newValues };
          history.replace({
            pathname: selectModePageUrl,
            search: queryString.stringify(newQs),
          });
        }
        break;
      }
      default:
        break;
    }
    return true;
  }
};
